import ImeScorecardSectionDataModel from '../data-models/ImeScorecardSection.DataModel';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getImeScorecardSections(scorecardSectionId: number, abortSignal: AbortSignal): Promise<ImeScorecardSectionDataModel> {
    return apiGet<ImeScorecardSectionDataModel>('/ime-scorecard-sections/' + scorecardSectionId, abortSignal);
}
